<template>
  <InertiaLink :href="to" :class="activeClassString">
    <slot></slot>
  </InertiaLink>
</template>

<script>
export default {
  name: 'RouterLink',

  props: {
    to: {
      type: [String, Object],
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    custom: Boolean,
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    activeRegex: RegExp,
    ariaCurrentValue: {
      type: String,
      default: 'page'
    },
    event: {
      type: [String, Array],
      default: 'click'
    }
  },

  computed: {
    url() {
      return this.$page.url
    },

    isExactActive() {
      const url = new URL(window.location.protocol + '//' + window.location.hostname + this.url)
      return (url.protocol + '//' + url.host + url.pathname) === this.to
    },

    isActive() {
      const url = new URL(window.location.protocol + '//' + window.location.hostname + this.url)
      const address = (url.protocol + '//' + url.host + url.pathname)
      if (this.activeRegex) {
        this.activeRegex.test(address)
      }
      return address.startsWith(this.to)
    },

    activeClassString() {
      return this.exact
        ? this.isExactActive
          ? this.exactActiveClass : ''
        : this.isActive
          ? this.activeClass : ''
    }
  }
}
</script>
